import { useEffect, useState } from 'react';
import { ImpulseSpinner } from 'react-spinners-kit';
import { useDispatch } from 'react-redux';
import { useParams } from 'react-router-dom';

import noReviewsFoundImg from 'assets/noReviewsFound.png';

import CreateReview from 'Pages/TeamDashboard/CreateReview';

import { setCurrentRecord } from 'Redux/Actions/historyActions';

import { getPublicDesignReview } from 'services/teamDashboardReviews';

import styles from './styles.module.scss';

const ShareDesignReview = () => {
  const { reviewUuid } = useParams();
  const dispatch = useDispatch();
  const [reviewData, setReviewData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchDesignReview = async () => {
      if (!reviewUuid) {
        setError('Invalid review ID');
        setLoading(false);

        return;
      }

      try {
        setLoading(true);
        setError(null);

        const data = await getPublicDesignReview(reviewUuid);

        setReviewData(data);

        // Set the current record in Redux state for components that depend on it
        dispatch(setCurrentRecord(data));
      }
      catch (err) {
        setError(err.message || 'Network error occurred');
      }
      finally {
        setLoading(false);
      }
    };

    fetchDesignReview();
  }, [reviewUuid, dispatch]);

  // Cleanup: Clear current record when component unmounts
  useEffect(() => () => {
    dispatch(setCurrentRecord(null));
  }, [dispatch]);

  if (loading) {
    return (
      <div className={styles['loader-container']}>
        <ImpulseSpinner frontColor={'#28BDAE'} />
      </div>
    );
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50">
        <div className="flex flex-col items-center text-center">
          <img src={noReviewsFoundImg} alt="No reviews found" className="w-36 2xl:w-52 h-auto mb-4" />
          <h1 className="text-2xl font-semibold text-gray-900 mb-2">
            Design Review Not Found
          </h1>
          <p className="text-sm text-gray-500">
            The design review you're looking for doesn't exist or has been removed.
          </p>
        </div>
      </div>
    );
  }

  if (reviewData) {
    // Handle close for public view - redirect to home or show message
    const handleClose = () => {
      window.location.href = '/';
    };

    return (
      <CreateReview
        onClose={handleClose}
        existingReviewData={reviewData}
        isPublicView
      />
    );
  }

  return null;
};

ShareDesignReview.propTypes = {};

export default ShareDesignReview;
